import { UserCookieSettings } from "app/modules/analytics/analyticsTypes";
import { SET_USER_COOKIE_SETTINGS } from "app/modules/analytics/redux/analyticsActionsConstants";

export const setUserCookieSettings = (cookieSettings: UserCookieSettings) => ({
	type: SET_USER_COOKIE_SETTINGS,
	payload: {
		cookieSettings,
	}
});